export const CHANGE_GITHUB_GRAPH_YEAR = 'CHANGE_GITHUB_GRAPH_YEAR';
